import React from "react";
import "moment/min/locales";
import { Spin } from "antd";
import { Route, Switch } from "react-router-dom";
import {
  SignInPage,
  SignUpPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  LogoutPage,
  E404Page,
  E403Page,
  RoutePlansPage,
  RoutePlanDetailPage,
  OrdersPage,
  OrdersNewPage,
  OrdersDetailPage,
  OrdersUploadPage,
  DriversPage,
  GroupsPage,
  SettingsPage,
  CompaniesPage,
  CompanyAdminsPage,
  UsersPage,
  RoutePlanAddOrdersPage,
  RoutePlanAddDriversPage,
  GroupsInvitePage,
  RoutePage,
  LiveTrackingPage,
  MessageLogsPage,
  PartnersPage,
  PartnerCompaniesPage,
  PartnerCompanyAdminsPage,
  ContactLocationsPage,
  ContactLocationsUploadPage,
  ReportPages,
  PublicOrder,
} from "../components/Pages";
import { PrivateRoute, PublicRoute, Authorize } from "../modules/auth/containers";
import AppError from "./AppError";
import AppMessage from "./AppMessage";
import { useSelector } from "react-redux";

const CompanyAdmin = Authorize(["company_admin", "admin"], E403Page);
const Admin = Authorize(["admin"], E403Page);
const Partner = Authorize(["partner"], E403Page);
const CompanyAdminUser = Authorize(["company_admin", "admin", "user"], E403Page);

const CanSetting = Authorize(["company_admin", "admin", "user", "partner"], E403Page);

const checkPublicSubdomain = url => {
  const regex = /^https?:\/\/public[-\w]*\.(parcelizer\.com|nordicrouting\.se)/i;
  return regex.test(url);
};

const App = () => {
  const globalLoading = useSelector(state => state.common.globalLoading);

  return (
    <Spin spinning={globalLoading} wrapperClassName="wrap-spin">
      <AppError />
      <AppMessage />
      <>
        {checkPublicSubdomain(window.location.href) ? (
          <Switch>
            <Route exact path="/:orderCode" component={PublicOrder} />
            <Route path="/*" component={E404Page} />
          </Switch>
        ) : (
          <Switch>
            <Route exact path="/login" component={SignInPage} />
            <Route exact path="/register" component={SignUpPage} />
            <Route exact path="/forgot-password" component={ForgotPasswordPage} />
            <Route exact path="/reset-password" component={ResetPasswordPage} />
            <Route exact path="/logout" component={LogoutPage} />
            <Route exact path="/s/:stopId" component={LiveTrackingPage} />
            <PublicRoute
              exact
              path={`/${process.env.REACT_APP_ENV === "staging" ? "rr" : "r"}/:routeId`}
              component={RoutePage}
            />
            <PublicRoute exact path="/tracking/:orderCode" component={OrdersDetailPage} />
            <PrivateRoute key="rs-1-1" exact path="/(route-plans)?" component={CompanyAdminUser(RoutePlansPage)} />
            <PrivateRoute
              key="rs-1-1-2"
              exact
              path="/route-plans/:id/add-orders"
              component={CompanyAdmin(RoutePlanAddOrdersPage)}
            />
            <PrivateRoute
              key="rs-1-1-3"
              exact
              path="/route-plans/:id/add-drivers"
              component={CompanyAdmin(RoutePlanAddDriversPage)}
            />
            <PrivateRoute
              key="rs-1-1-1"
              exact
              path="/route-plans/:id/:type"
              component={CompanyAdminUser(RoutePlanDetailPage)}
            />
            <PrivateRoute
              key="rs-1-1-1"
              exact
              path="/route-plans/:id"
              component={CompanyAdminUser(RoutePlanDetailPage)}
            />
            <PrivateRoute key="rs-1-3" exact path="/reports" component={CompanyAdminUser(ReportPages)} />
            <PrivateRoute key="rs-1-3" exact path="/orders" component={CompanyAdminUser(OrdersPage)} />
            <PrivateRoute key="rs-1-1-2-1" exact path="/orders/new" component={CompanyAdmin(OrdersNewPage)} />
            <PrivateRoute key="rs-1-1-2-1" exact path="/orders/upload" component={CompanyAdmin(OrdersUploadPage)} />
            <PrivateRoute key="rs-1-3" exact path="/orders/:id" component={CompanyAdminUser(OrdersDetailPage)} />
            <PrivateRoute key="rs-1-4" exact path="/drivers" component={CompanyAdmin(DriversPage)} />
            <PrivateRoute key="rs-1-5" exact path="/groups" component={CompanyAdmin(GroupsPage)} />
            <PrivateRoute key="rs-1-6" exact path="/users" component={CompanyAdmin(UsersPage)} />
            <PrivateRoute
              key="rs-1-7"
              exact
              path="/settings/contact-list/upload"
              component={CanSetting(ContactLocationsUploadPage)}
            />
            <PrivateRoute
              key="rs-1-7"
              exact
              path="/settings/contact-list"
              component={CanSetting(ContactLocationsPage)}
            />
            <PrivateRoute key="rs-1-7" exact path="/settings/:settingType" component={CanSetting(SettingsPage)} />
            <PrivateRoute key="rs-1-7" exact path="/settings" component={CanSetting(SettingsPage)} />
            <PrivateRoute key="rs-1-6" exact path="/message-logs" component={CompanyAdmin(MessageLogsPage)} />
            <PrivateRoute key="rs-1-8" exact path="/companies" component={Admin(CompaniesPage)} />
            <PrivateRoute key="rs-1-9" exact path="/company-admins" component={Admin(CompanyAdminsPage)} />
            <PrivateRoute key="rs-1-10" exact path="/groups/invite" component={GroupsInvitePage} />
            <PrivateRoute key="rs-1-11" exact path="/partners" component={Admin(PartnersPage)} />
            <PrivateRoute key="rs-1-22" exact path="/reports-orders-by-company" component={Admin(ReportPages)} />
            <PrivateRoute key="rs-1-8" exact path="/partner/companies" component={Partner(PartnerCompaniesPage)} />
            <PrivateRoute
              key="rs-1-8"
              exact
              path="/partner/company-admins"
              component={Partner(PartnerCompanyAdminsPage)}
            />
            <Route path="/*" component={E404Page} />
          </Switch>
        )}
      </>
    </Spin>
  );
};

export default App;
